import { render } from "./GCompaniasModal.vue?vue&type=template&id=1fcfeab7"
import script from "./GCompaniasModal.vue?vue&type=script&lang=js"
export * from "./GCompaniasModal.vue?vue&type=script&lang=js"

import "./GCompaniasModal.vue?vue&type=style&index=0&id=1fcfeab7&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__